export default "/app/themes/majeures/build/images/avatar2.svg?50274e82c73adad24f453d82f1c0cfa7";